<template>
	<div class="arm-nav-menu">
		<o-nav-main
			v-for="(items, type) in setup.navigation"
			:key="items.length"
			:ref="type === 'main' ? setup._navMain : undefined"
			:class="{ 'arm-nav-menu-empty': !items.length }"
			:items="items">
			<template #append="{ item }: { item: ArmNavSlugedItem }">
				<o-icon
					v-if="!setup.isTouch && !item.children?.length && !item.line && item.favoritetype !== undefined && (item.to as any)?.name !== 'Dashboard'"
					class="arm-nav-menu__favorite-icon"
					:class="{ 'arm-nav-menu__favorite-icon--active': setup.itemIsFavorite(item) }"
					font-icon="icon-interface-favorite-star-bold"
					:loading="item.processing"
					@click.prevent="setup.toggleMenuItemFavoriteAsync(item)"/>

				<div
					v-if="item.label === 'Actualités' && unreadNewsCount"
					class="arm-nav-menu__item-counter">
					{{ unreadNewsCount }}
				</div>
			</template>

			<template #default="{ item }: { item: ArmNavSlugedItem }">
				<div
					class="arm-nav-menu__item"
					:class="{
						'arm-nav-menu__item--parent': item.children?.length || setup.self.isTempWorker(),
						'arm-nav-menu__item--section-title': item.sectionTitle,
					}">
					{{ item.label }}
					<span
						v-if="item.slug"
						class="arm-nav-menu__slug">{{ item.slug.replace('/', ' / ') }}</span>
				</div>
			</template>
		</o-nav-main>

		<div
			v-if="setup.responsive.onPhone"
			id="tour-navigation-logout-phone"
			class="orion-nav-main__item"
			@click="setup.self.logoutAsync()">
			<o-icon
				font-icon="icon-interface-logout-circle"/>
			Déconnexion
		</div>
	</div>
</template>

<script setup lang="ts">
import SharedMainNavSetupService from '@/setup/shared/SharedMainNavSetupService';
const props = defineProps(SharedMainNavSetupService.props);
const setup = new SharedMainNavSetupService(props);
</script>
